import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { IoClose } from "react-icons/io5";

const CustomModal = ({ isOpen, onClose, children }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center p-2 sm:p-4 md:p-6 lg:p-10 pointer-events-auto"
            onClick={onClose}
        >
            <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md transition-opacity animate-in fade-in duration-300" />

            <div
                className="relative w-full max-w-6xl h-full max-h-[95vh] lg:max-h-[90vh] bg-white rounded-[1rem] sm:rounded-[2rem] shadow-[0_20px_70px_-10px_rgba(0,0,0,0.3)] overflow-hidden flex flex-col transform transition-all animate-in slide-in-from-bottom-8 duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="absolute top-3 right-3 sm:top-6 sm:right-6 z-[60] w-8 h-8 sm:w-12 sm:h-12 flex items-center justify-center bg-white/80 hover:bg-white text-slate-900 rounded-xl sm:rounded-2xl shadow-xl transition-all hover:rotate-90 hover:scale-110 active:scale-90 backdrop-blur-md border border-slate-900 border-[2px] sm:border-[3px] border-solid"
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    <IoClose className="text-[16px] sm:text-[24px]" />
                </button>

                <div className="flex-1 overflow-hidden h-full">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default CustomModal;
